import { createContext, useContext, useEffect } from "react";
import { ClientOnly } from "vite-react-ssg";

type FathomEventOptions = {
  _value?: number;
  _site_id?: string;
} | null;

interface FathomContextType {
  trackEvent: (eventName: string, options?: FathomEventOptions) => void;
}

const FathomContext = createContext<FathomContextType | undefined>(undefined);

function FathomScript() {
    useEffect(() => {
        const script = document.createElement('script');
      
        script.src = "/js/fathom.js";
        script.async = true;
        script.setAttribute('data-site', 'VEAMDCGB');
        script.setAttribute('defer', '');
      
        document.head.appendChild(script);
      
        return () => {
          document.head.removeChild(script);
        }
    }, []);

    return (<></>)
}

export function FathomProvider({ children }: { children: React.ReactNode }) {
    const trackEvent = (eventName: string, options?: FathomEventOptions) => {
        if (typeof window !== 'undefined' && (window as any).fathom) {
            (window as any).fathom.trackEvent(eventName, options);
        }
    };

    return (
        <FathomContext.Provider value={{ trackEvent }}>
            <ClientOnly>
                {() => <>
                    <FathomScript />
                </>}
            </ClientOnly>
            {children}
        </FathomContext.Provider>
    )
}

export function useFathom() {
    const context = useContext(FathomContext);
    if (context === undefined) {
        throw new Error('useFathom must be used within a FathomProvider');
    }
    return context;
}